import React,{Component} from 'react'
import Link from 'react-router'
import {language} from 'UTIL/common'
export default class SearchDate extends Component{
    constructor(props){
        super(props);
        this.state = {
            min:'',
            max:'',
        }
    }
    componentDidMount(){
        const id = this.props.id;
        new pickerDateRange(id, {
            isTodayValid: true,
            startDate: new Date().Format("yyyy-MM-dd"),
            endDate: new Date().Format("yyyy-MM-dd"),
            needCompare: false,
            defaultText: ' 至 ',
            autoSubmit: true,
            maxValidDateL:'',
            inputTrigger: 'input_trigger1',
            theme: 'ta',
            stopToday : false,
        });
    }
     render(){
        return (<div className="form-group clearfix fl">
             <label className="control-name">{language()[this.props.name]}</label>
         <input type="text" className="form-control" autocomplete="off"
                id={this.props.id} style={{width:'220px'}}/>
     </div>

     )
     }
}

//日期搜索
//<SearchDate id='' name='' />



// WEBPACK FOOTER //
// ./modules/component/search/searchDate.js